import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button3D } from '@/components/ui/button-3d';
import { Camera, Trash2, RefreshCw } from 'lucide-react';
import { StorageImage } from '@/components/ui/StorageImage';

interface ItemPhotoModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  imageUrl: string;
  itemName: string;
  onChangePhoto: () => void;
  onRemovePhoto: () => void;
  isLoading?: boolean;
}

export function ItemPhotoModal({
  open,
  onOpenChange,
  imageUrl,
  itemName,
  onChangePhoto,
  onRemovePhoto,
  isLoading = false,
}: ItemPhotoModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-center">Foto do item</DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4">
          {/* Image Preview */}
          <div className="relative aspect-square w-full max-w-[300px] mx-auto rounded-lg overflow-hidden bg-muted">
            <StorageImage
              src={imageUrl}
              alt={itemName}
              className="w-full h-full object-cover"
            />
          </div>

          {/* Item Name */}
          <p className="text-center text-sm text-muted-foreground font-medium">
            {itemName || 'Item sem nome'}
          </p>

          {/* Actions */}
          <div className="flex gap-3">
            <Button3D
              color="green"
              className="flex-1"
              onClick={() => {
                onChangePhoto();
                onOpenChange(false);
              }}
              disabled={isLoading}
            >
              <RefreshCw className="mr-2 h-4 w-4" />
              Alterar foto
            </Button3D>
            <Button3D
              color="red"
              className="flex-1"
              onClick={() => {
                onRemovePhoto();
                onOpenChange(false);
              }}
              disabled={isLoading}
            >
              <Trash2 className="mr-2 h-4 w-4" />
              Remover foto
            </Button3D>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
